import request from '@/utils/request';


export function addCart(data) {
  return request({
    url: '/wx/cart/add',
    method: 'post',
    data: data
  })
}
export function updateCart(data) {
  return request({
    url: '/wx/cart/update',
    method: 'post',
    data: data
  })
}
//查看购物车
export function getCartInfo(params) {
  return request({
    url: '/wx/cart/index',
    method: 'get',
    params: params
  });
}
//删除购物车的商品
export function deleteCart(data) {
  return request({
    url: '/wx/cart/delete',
    data: data,
    method: 'post'
  })
}
// 购物车商品货品勾选状态
export function checkedCart(data) {
  return request({
    url: '/wx/cart/checked',
    data: data,
    method: 'post'
  })
}
//下单确认
export function getCheckoutInfo(cartId, addressId, couponId, grouponRulesId) {
  return request({
    url: '/wx/cart/checkout?cartId=' + cartId + '&addressId=' + addressId + '&couponId=' + couponId + '&grouponRulesId=' + grouponRulesId,
    method: 'get'
  })
}
//立即购买
export function fastAdd(data) {
  return request({
    url: '/wx/cart/fastadd',
    method: 'post',
    data: data,
  });
}



// WEBPACK FOOTER //
// ./src/api/cart/cart.js